import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import AdminLayout from './Component/AdminLayout';

import Home from './Component/Pages/Home';
import CustomerReport from './Component/Pages/CustomerReport';
import BusOwnerManage from './Component/Pages/BusOwnerManage';
import BookingManage from './Component/Pages/BookingManage';
import PaymentReport from './Component/Pages/PaymentReport';
import CouponManage from './Component/Pages/CouponManage';
import InfluencerManage from './Component/Pages/InfluencerManage';
import OwnerCommission from './Component/Pages/OwnerCommission';
import Login from './Component/Pages/Login';
import ForgotPassword from './Component/Pages/ForgotPassword';
import InfluencerCommission from './Component/Pages/InfluencerCommission';
import ProfileManagement from './Component/Pages/ProfileManagement';
import RouteManage from './Component/Pages/RouteManage';
import TermsAndConditions from './Component/Pages/TermsAndConditions';
import DriverManagement from './Component/Pages/DriverManagement';
import ConductorManagement from './Component/Pages/ConductorManagement';
import SeatManagement from './Component/Pages/SeatManagement';
import BusFareChart from './Component/Pages/BusFareChart';
import EmployeeManagement from './Component/Pages/EmployeeManagement';
import FreelancerManagement from './Component/Pages/FreelancerManagement';
import ProfitReport from './Component/Pages/ProfitReport';
import AdminExpensesReport from './Component/Pages/AdminExpensesReport';
import GSTAdminPanel from './Component/Pages/GSTAdminPanel';
import MasterRouteManage from './Component/Pages/MasterRouteManage';
import GSTManagement from './Component/Pages/GSTManagement';
import PlatformFeeManagement from './Component/Pages/PlatformFeeManagement';
import BusManagement from './Component/Pages/BusManagement';
import BookingPolicyManagement from './Component/Pages/BookingPolicyManagement';
import BusRouteScheduleManage from './Component/Pages/BusRouteScheduleManage';
import CustomerCareManagement from './Component/Pages/CustomerCareManagement';
import PublicDownloadPage from './Component/Pages/PublicDownloadPage';
import BusReport from './Component/Pages/BusReport';
import BusOwnerReport from './Component/Pages/BusOwnerReport';
import VersionManagement from './Component/Pages/VersionManagement';
import ViewRoutesList from './Component/Pages/ViewRoutesList';

const ProtectedRoute = ({ children, allowedRoles, userRole }) => {
  const { token } = useSelector((state) => state.user);
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  if (allowedRoles && !allowedRoles.includes(userRole?.toLowerCase())) {
    return <Navigate to="/unauthorized" replace />;
  }
  
  return children;
};

const UnauthorizedPage = () => {
  return (
    <div style={{
      textAlign: 'center',
      padding: '50px',
      maxWidth: '500px',
      margin: '100px auto'
    }}>
      <div style={{
        fontSize: '48px',
        marginBottom: '20px',
        color: '#dc3545'
      }}>
        ⚠️
      </div>
      <h2 style={{
        color: '#dc3545',
        marginBottom: '20px',
        fontSize: '24px',
        fontWeight: '600'
      }}>
        Unauthorized Access
      </h2>
      <p style={{
        marginBottom: '30px',
        color: '#666',
        fontSize: '16px',
        lineHeight: '1.6'
      }}>
        You don't have permission to access this page.
        Please contact your system administrator if you believe this is a mistake.
      </p>
      <button
        onClick={() => window.location.href = '/dashboard'}
        style={{
          padding: '12px 30px',
          backgroundColor: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: '500'
        }}
      >
        Go to Dashboard
      </button>
    </div>
  );
};

const AppRoutes = () => {
  const { token, loginData } = useSelector((state) => state.user);
  const userRole = loginData?.user?.role || loginData?.role || 'admin';
  const isLoggedIn = !!token;

  return (
    <Routes>
      <Route path="/download" element={<PublicDownloadPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/unauthorized" element={<UnauthorizedPage />} />

      <Route path="/" element={
        <ProtectedRoute>
          <AdminLayout />
        </ProtectedRoute>
      }>
        <Route index element={<Home />} />
        <Route path="dashboard" element={<Home />} />

        <Route path="customers" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <CustomerReport />
          </ProtectedRoute>
        } />

        <Route path="GSTManagement" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <GSTManagement />
          </ProtectedRoute>
        } />

        <Route path="GSTAdminPanel" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <GSTAdminPanel />
          </ProtectedRoute>
        } />


        <Route path="drivers" element={
          <ProtectedRoute allowedRoles={['admin', 'freelancer']} userRole={userRole}>
            <DriverManagement />
          </ProtectedRoute>
        } />


        <Route path="conductors" element={
          <ProtectedRoute allowedRoles={['admin', 'freelancer']} userRole={userRole}>
            <ConductorManagement />
          </ProtectedRoute>
        } />


        <Route path="bus-owners" element={
          <ProtectedRoute allowedRoles={['admin', 'freelancer']} userRole={userRole}>
            <BusOwnerManage />
          </ProtectedRoute>
        } />


        <Route path="employees" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <EmployeeManagement />
          </ProtectedRoute>
        } />


        <Route path="freelancers" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <FreelancerManagement />
          </ProtectedRoute>
        } />


        <Route path="routes" element={
          <ProtectedRoute allowedRoles={['admin', 'freelancer']} userRole={userRole}>
            <RouteManage />
          </ProtectedRoute>
        } />

         <Route path="view-routes" element={
          <ProtectedRoute allowedRoles={['admin', 'freelancer']} userRole={userRole}>
            <ViewRoutesList />
          </ProtectedRoute>
        } />

        <Route path="masterroutes" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <MasterRouteManage />
          </ProtectedRoute>
        } />


        <Route path="bookings" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <BookingManage />
          </ProtectedRoute>
        } />


        <Route path="payments" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <PaymentReport />
          </ProtectedRoute>
        } />


        <Route path="coupons" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <CouponManage />
          </ProtectedRoute>
        } />


        <Route path="influencers" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <InfluencerManage />
          </ProtectedRoute>
        } />


        <Route path="owner-commissions" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <OwnerCommission />
          </ProtectedRoute>
        } />

        <Route path="influencer-commissions" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <InfluencerCommission />
          </ProtectedRoute>
        } />


        <Route path="profit-report" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <ProfitReport />
          </ProtectedRoute>
        } />

        <Route path="expenses-report" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <AdminExpensesReport />
          </ProtectedRoute>
        } />


        <Route path="seat-management" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <SeatManagement />
          </ProtectedRoute>
        } />

        <Route path="BusManagement" element={
                  <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
                    <BusManagement />
                  </ProtectedRoute>
                } />

        <Route path="versions" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <VersionManagement/>
          </ProtectedRoute>
        } />

        <Route path="platform-management" element={
        <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
          <PlatformFeeManagement />
        </ProtectedRoute>
      } />


        <Route path="customer-care" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <CustomerCareManagement />
          </ProtectedRoute>
        } />


        <Route path="bus-report" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <BusReport />
          </ProtectedRoute>
        } />

        <Route path="bus-owner-report" element={
         <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
           <BusOwnerReport />
         </ProtectedRoute>
       } />


        <Route path="profile" element={
          <ProtectedRoute>
            <ProfileManagement />
          </ProtectedRoute>
        } />


        <Route path="terms" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <TermsAndConditions />
          </ProtectedRoute>
        } />


        <Route path="BookingPolicyManagement" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <BookingPolicyManagement />
          </ProtectedRoute>
        } />


        <Route path="chart" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <BusFareChart />
          </ProtectedRoute>
        } />

        <Route path="busroutes" element={
          <ProtectedRoute allowedRoles={['admin']} userRole={userRole}>
            <BusRouteScheduleManage />
          </ProtectedRoute>
        } />
      </Route>


      <Route path="*" element={
        isLoggedIn ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />
      } />
    </Routes>
  );
};

export default AppRoutes;